export const filterSpecialCharacters = (text: string) => text.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, '')
